import { render, staticRenderFns } from "./ElementScaleTableColumn.vue?vue&type=template&id=533507a2&scoped=true"
import script from "./ElementScaleTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScaleTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementScaleTableColumn.vue?vue&type=style&index=0&id=533507a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533507a2",
  null
  
)

export default component.exports